module.exports = __webpack_public_path__ + "img/26.d9a26ec7.jpg";